module.exports = __webpack_public_path__ + "static/media/vf_mcardigan_core.38d70d29.svg";